import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { changeView } from "./../actions/assessment";
import { SaveUserStateToServerHelper } from "./Helper";
import config from "../config/config-secret.json";

import { Translate } from "react-redux-i18n";

export class SessionDetails extends Component {
  componentDidMount() {
    SaveUserStateToServerHelper(this.props.assessment);
  }

  startOpenQuestion = () => {
    const {
      is_ptsd,
      assessment,
      enabled_open_question,
      has_job_application,
      start,
      show_ptsd,
    } = this.props;

    if (is_ptsd) {
      show_ptsd();
      return;
    }

    if (assessment.current_question_number === 1) {
      const tester_id = assessment.tester_id;

      axios
        .post(config.API_URL + "/administer_test/started/", {
          tester_id: tester_id,
        })
        .then((res) => {
          // document.querySelector("#initloader").style.display = "none";
        })
        .catch((error) => {
          // document.querySelector("#initloader").style.display = "none";
          alert("Something went wrong. Please refresh the page.");
        });
    }

    let nextView = "instruction";
    if (enabled_open_question === true) {
      nextView = "open_question_instructions";
    } else if (has_job_application === true) {
      nextView = "job_application";
    }
    start(nextView);
  };

  render() {
    return (
      <div className="main container-fluid h-100">
        <div className="row h-100 justify-content-center align-items-center">
          <div className="col-12">
            <div className="container">
              <div className="row  justify-content-center ">
                <div className="col-md-6 ">
                  <div className="test-info ">
                    <h3 className="mt-4 mb-3 text-center">
                      <Translate value="session_details" />
                    </h3>
                    <p className="mb-4">
                      <Translate value="session_p1" />
                    </p>
                    {this.props.enabled_open_question && (
                      <p className="btn btn-outline-success btn-xl btn-block disabled">
                        <Translate value="open_question" />
                      </p>
                    )}
                    {this.props.has_job_application && (
                      <p className="btn btn-outline-success btn-xl btn-block disabled">
                        <Translate value="job_application" />
                      </p>
                    )}
                    {this.props.session.map((value, index) => {
                      return (
                        <p
                          key={index}
                          className="btn btn-outline-success btn-xl btn-block disabled"
                        >
                          {value.name}
                        </p>
                      );
                    })}
                    <div className="my-4 px-5">
                      <small>
                        <p>
                          <Translate value="session_before" />
                        </p>
                        <p>
                          <Translate value="session_p2" />
                        </p>
                      </small>
                    </div>
                    <div className="my-4 px-5">
                      <small>
                        <p>
                          <Translate value="session_p3" />
                        </p>
                      </small>
                    </div>
                    {this.props.enabled_open_question && (
                      <p className="est">
                        <Translate value="open_question_eta"></Translate>
                      </p>
                    )}
                    {this.props.has_job_application && (
                      <p className="est">
                        <Translate value="job_application_estimated_time" />
                      </p>
                    )}
                    <p className="est">
                      <Translate value="session_est" />
                      <br />
                      {this.props.approximate_time === 1 && (
                        <Translate value="session_one_minute_limit" />
                      )}
                      {this.props.approximate_time > 1 && (
                        <Translate
                          value="session_est_time_limit"
                          timed={this.props.approximate_time}
                        />
                      )}
                    </p>
                    <div className="button-wrap">
                      <button
                        className="btn btn-main btn-global btn-block"
                        onClick={this.startOpenQuestion}
                      >
                        <Translate value="start" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  session: state.assessment.sessions,
  approximate_time: state.assessment.approximate_time,
  has_job_application: state.assessment.has_job_application,
  enabled_open_question: state.assessment.enabled_open_question,
});

const mapDispatchToProps = (dispatch) => ({
  start: (instruction) => dispatch(changeView(instruction)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SessionDetails);
